export const PERFORMANCE_MEASURE_NAMES: Record<string, string> = {
  // when the app starts loading
  DSR_RENDERING_STARTED: 'dsrRenderingStarted',
  // when the app finished loading and pages are available (after user sign in)
  DSR_RENDERING_COMPLETED: 'dsrRenderingCompleted',
  // when the rooms page is first rendered
  DSR_ROOMS_RENDERING_STARTED: 'dsrRoomsRenderingStarted',
  // when rooms page has all the data to render the rooms in the table
  DSR_ROOMS_RENDERING_COMPLETED: 'dsrRoomsRenderingCompleted',
};
